/**
 * Helpers compartilhados para definicao/filtragem de colunas de tabela.
 *
 * Criado 2026-05-28 para padronizar o comportamento "coluna valor some
 * para usuario sem permissao preco:view". Antes, paginas que usavam
 * tabela custom (Marcenaria, Acabamento/Views, Terceiros/Views,
 * PlanejamentoEntregas) NAO removiam a coluna — apenas mostravam o
 * valor mascarado com MoneyCell, ocupando espaco util da tela.
 *
 * Uso tipico em pagina com ColumnResizeProvider:
 *   const { precosVisiveis } = usePrecosVisiveis();
 *   const cols = useMemo(
 *     () => filtrarColunasPorPrecos(COLS_FILA, precosVisiveis),
 *     [precosVisiveis],
 *   );
 *
 * Keys reconhecidas como "coluna de valor" (case-insensitive):
 *   - valor, preco, total
 *   - receita (para Marceneiros)
 *
 * Override: declarando `requerPermissao: null` na coluna, ela e
 * preservada mesmo sem permissao (caso especial documentado).
 */

const KEYS_VALOR = new Set([
  "valor",
  "preco",
  "total",
  "receita",
]);

/**
 * Filtra colunas removendo as de valor quando o usuario nao tem permissao.
 *
 * @param {Array<{key: string, requerPermissao?: string|null}>} colunas
 * @param {boolean} precosVisiveis - true se hasPermission("preco:view")
 * @returns {Array} colunas filtradas
 */
export function filtrarColunasPorPrecos(colunas, precosVisiveis) {
  if (precosVisiveis) return colunas;
  return colunas.filter((col) => {
    if (!col || typeof col.key !== "string") return true;
    // Override explicito (preserva mesmo sem permissao).
    if (col.requerPermissao === null) return true;
    const keyLower = col.key.toLowerCase();
    return !KEYS_VALOR.has(keyLower);
  });
}
